import {
    FETCH_MANAGER_BEGIN, FETCH_MANAGER_SUCCESS, FETCH_MANAGER_FAILURE,
    FETCH_USERDETAILS_BEGIN, FETCH_USERDETAILS_SUCCESS, FETCH_USERDETAILS_FAILURE,
    FETCH_DS_BEGIN,
    FETCH_DS_SUCCESS,
    FETCH_DS_FAILURE,
    FETCH_ENUM_BEGIN,
    FETCH_ENUM_SUCCESS,
    FETCH_ENUM_FAILURE,
    FETCH_ACTIVEMENU_SUCCESS,
    FETCH_ASSETLIST_SEARCH_BEGIN,
    FETCH_ASSETLIST_SEARCH_FAILURE,
    FETCH_ASSETLIST_SEARCH_SUCCESS,
    FETCH_ACTIVESUBMENU_SUCCESS,
    FETCH_CONTACT_BEGIN,
    FETCH_CONTACTLEAD_SUCCESS,
    FETCH_CONTACTRANK_SUCCESS,
    FETCH_CONTACTREPTYPE_SUCCESS,
    FETCH_CONTACTUPDATESTATUS_SUCCESS,
    FETCH_CONTACTCATEGORY_SUCCESS,

    FETCH_TAXENTITIES_BEGIN,
    FETCH_TAXENTITIES_SUCCESS,
    FETCH_TAXENTITIES_FAILURE,
    FETCH_DEFAULTENTITIES_BEGIN,
    FETCH_DEFAULTENTITIES_SUCCESS,
    FETCH_DEFAULTENTITIES_FAILURE,
    FETCH_LIQUIDITYREQUIREDNOTICE_BEGIN,
    FETCH_LIQUIDITYREQUIREDNOTICE_FAILURE,
    FETCH_LIQUIDITYREQUIREDNOTICE_SUCCESS,
    FETCH_LIQUIDITYLOCKTYPE_BEGIN,
    FETCH_LIQUIDITYLOCKTYPE_SUCCESS,
    FETCH_LIQUIDITYLOCKTYPE_FAILURE,
    FETCH_LIQUIDITYLOCKUPFREQUENCY_BEGIN,
    FETCH_LIQUIDITYLOCKUPFREQUENCY_SUCCESS,
    FETCH_LIQUIDITYLOCKUPFREQUENCY_FAILURE,
    FETCH_FREQUENCY_1_BEGIN,
    FETCH_FREQUENCY_1_SUCCESS,
    FETCH_FREQUENCY_1_FAILURE,
    FETCH_FREQUENCY_2_BEGIN,
    FETCH_FREQUENCY_2_SUCCESS,
    FETCH_FREQUENCY_2_FAILURE,
    FETCH_FAMILIES_FAILURE,
    FETCH_FAMILIES_SUCCESS,
    FETCH_FAMILIES_BEGIN,
    FETCH_COUNTRY_BEGIN,
    FETCH_COUNTRY_SUCCESS,
    FETCH_COUNTRY_FAILURE,
    FETCH_STATES_BEGIN,
    FETCH_STATES_SUCCESS,
    FETCH_STATES_FAILURE,
}
    from '../constants/Common';

const initialState = {
    managerContacts: [],
    isManagerContactsLoading: false,
    error: "",
    userDetails: {},
    isUserDetailsLoading: false,
    errorLoadingUserDetails: null,
    DataSourcelist: [],
    enumValues: [],
    activeMenuID: null,
    activeSubMenuID: null,
    assetListSearched: [],
    isAssetListSearchedLoading: null,
    assetListSearchedError: null,
    selectedEntities:{},
    ContactLeadData:[],
    ContactRankData:[],
    ContactRepTypeData:[],
    ContactUpdateStatusData:[],
    ContactCategoryData:[],

    LiquidityRequriedNotice:[],
    LiquidityLockUpType:[],
    LiquidityLockUpFrequency:[],


    Frequency1:[],
    Frequency2:[],
    
    TaxEntitiesList:[],
    Family:[],

    country:[],
    state:[]
}


export const getManagerContactsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_MANAGER_BEGIN: {
            return {
                ...state,
                isManagerContactsLoading: true,
                error: null,
            };
        }
        case FETCH_MANAGER_FAILURE:
            return {
                ...state,
                isManagerContactsLoading: false,
                managerContacts: null
            };
        case FETCH_MANAGER_SUCCESS:
            return {
                ...state,
                managerContacts: payload.managerContacts,
                isManagerContactsLoading: true,
            };
        default:
            return state;
    }
}

export const getCommonReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case FETCH_USERDETAILS_BEGIN: {
        return {
          ...state,
          isUserDetailsLoading: true,
          errorLoadingUserDetails: null,
        };
      }
      case FETCH_USERDETAILS_FAILURE:
        return {
          ...state,
          isUserDetailsLoading: false,
          errorLoadingUserDetails: payload.errorMessage,
        };
      case FETCH_USERDETAILS_SUCCESS:
        return {
          ...state,
          userDetails: payload.userDetails,
          isUserDetailsLoading: false,
        };
      case FETCH_ACTIVEMENU_SUCCESS:
        return {
          ...state,
          activeMenuID: payload.menuID,
        };
      case FETCH_ACTIVESUBMENU_SUCCESS:
        return {
          ...state,
          activeMenuID: payload.parentMenuID,
          activeSubMenuID: payload.menuID,
        };
      case FETCH_ASSETLIST_SEARCH_BEGIN: {
        return {
          ...state,
          isAssetListSearchedLoading: true,
          assetListSearchedError: null,
          assetListSearched: [],
        };
      }
      case FETCH_ASSETLIST_SEARCH_FAILURE:
        return {
          ...state,
          isAssetListSearchedLoading: false,
          assetListSearchedError: payload.error,
          assetListSearched: [],
        };
      case FETCH_ASSETLIST_SEARCH_SUCCESS:
        return {
          ...state,
          isAssetListSearchedLoading: false,
          assetListSearchedError: null,
          assetListSearched: payload.assetItems,
        };

      case FETCH_TAXENTITIES_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
      case FETCH_TAXENTITIES_FAILURE:
        return {
          ...state,
          isLoading: true,
          error: payload.error,
        };
      case FETCH_TAXENTITIES_SUCCESS:
        return {
          ...state,
          isLoading: false,
          TaxEntitiesList: payload.TaxEntitiesList,
        };
      case FETCH_DEFAULTENTITIES_BEGIN: {
        return {
          ...state,
        };
      }
      case FETCH_DEFAULTENTITIES_FAILURE:
        return {
          ...state,
        };
      case FETCH_DEFAULTENTITIES_SUCCESS:
        return {
          ...state,
          isLoading: false,
          selectedEntities: payload.entites,
        };
      case FETCH_LIQUIDITYREQUIREDNOTICE_BEGIN:
        return {
          ...state,
          LiquidityRequriedNotice: [],
        };
      case FETCH_LIQUIDITYREQUIREDNOTICE_SUCCESS:
        return {
          ...state,
          LiquidityRequriedNotice: payload.RequriedNotice,
        };
      case FETCH_LIQUIDITYREQUIREDNOTICE_FAILURE:
        return {
          ...state,
          LiquidityRequriedNotice: [],
        };
      case FETCH_LIQUIDITYLOCKTYPE_BEGIN:
        return {
          ...state,
          LiquidityLockUpType: [],
        };
      case FETCH_LIQUIDITYLOCKTYPE_SUCCESS:
        return {
          ...state,
          LiquidityLockUpType: payload.LockType,
        };
      case FETCH_LIQUIDITYLOCKTYPE_FAILURE:
        return {
          ...state,
          LiquidityLockUpType: [],
        };
      case FETCH_LIQUIDITYLOCKUPFREQUENCY_BEGIN:
        return {
          ...state,
          LiquidityLockUpFrequency: [],
        };
      case FETCH_LIQUIDITYLOCKUPFREQUENCY_SUCCESS:
        return {
          ...state,
          LiquidityLockUpFrequency: payload.LockUpFrequency,
        };
      case FETCH_LIQUIDITYLOCKUPFREQUENCY_FAILURE:
        return {
          ...state,
          LiquidityLockUpFrequency: [],
        };
      case FETCH_FREQUENCY_1_BEGIN:
        return {
          ...state,
          Frequency1: [],
        };
      case FETCH_FREQUENCY_1_SUCCESS:
        return {
          ...state,
          Frequency1: payload.Frequency,
        };
      case FETCH_FREQUENCY_1_FAILURE:
        return {
          ...state,
          Frequency1: [],
        };
      case FETCH_FREQUENCY_2_BEGIN:
        return {
          ...state,
          Frequency1: [],
        };
      case FETCH_FREQUENCY_2_SUCCESS:
        return {
          ...state,
          Frequency2: payload.Frequency,
        };
      case FETCH_FREQUENCY_2_FAILURE:
        return {
          ...state,
          Frequency1: [],
        };
        case FETCH_FAMILIES_BEGIN:
          return {
            ...state,
            Family: [],
          };
        case FETCH_FAMILIES_SUCCESS:
          return {
            ...state,
            Family: payload.Family,
          };
        case FETCH_FAMILIES_FAILURE:
          return {
            ...state,
            Family: [],
          };

          case FETCH_COUNTRY_BEGIN:
            return {
              ...state,
              country: [],
            };
          case FETCH_COUNTRY_SUCCESS:
            return {
              ...state,
              country: payload.country,
            };
          case FETCH_COUNTRY_FAILURE:
            return {
              ...state,
              country: [],
            };

            case FETCH_STATES_BEGIN:
            return {
              ...state,
              state: [],
            };
          case FETCH_STATES_SUCCESS:
            return {
              ...state,
              state: payload.state,
            };
          case FETCH_STATES_FAILURE:
            return {
              ...state,
              state: [],
            };


      default:
        return state;
    }
}


export default getManagerContactsReducer;


export const getDataSourceReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_DS_BEGIN: {
            return {
                ...state,

                DataSourcelist: null,
            };
        }
        case FETCH_DS_FAILURE:
            return {
                ...state,

                DataSourcelist: payload.errorMessage
            };
        case FETCH_DS_SUCCESS:
            return {
                ...state,
                DataSourcelist: payload.DataSourcelist,

            };
        default:
            return state;
    }
}

// Get Enumeration..

export const getEnumerationReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ENUM_BEGIN: {
            return {
                ...state,

                enumValues: null,
            };
        }
        case FETCH_ENUM_FAILURE:
            return {
                ...state,

                enumValues: payload.errorMessage
            };
        case FETCH_ENUM_SUCCESS:
            return {
                ...state,
                enumValues: payload.enumValues,

            };
        default:
            return state;
    }
}

export const getContactDetailsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_CONTACT_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ENUM_FAILURE:
            return {
                ...state,
                isLoading: true,
                error: payload.error,
            };
        case FETCH_CONTACTLEAD_SUCCESS:
            return {
                ...state,
                ContactLeadData: payload.ContactLeadData,
            };
            case FETCH_CONTACTRANK_SUCCESS:
            return {
                ...state,
                ContactRankData: payload.ContactRankData,
            };
            case FETCH_CONTACTREPTYPE_SUCCESS:
            return {
                ...state,
                ContactRepTypeData: payload.ContactRepTypeData,
            };
            case FETCH_CONTACTUPDATESTATUS_SUCCESS:
            return {
                ...state,
                ContactUpdateStatusData: payload.ContactUpdateStatusData,
            };
            case FETCH_CONTACTCATEGORY_SUCCESS:
            return {
                ...state,
                ContactCategoryData: payload.ContactCategoryData,
            };
        default:
            return state;
    }
}